import React from 'react';
import { Link } from 'react-router-dom';
import NewsletterSignup from '../NewsletterSignup';

const SiteFooter: React.FC = () => (
  <footer className="footer">
    <div className="wrap">
      <div>
        <div className="wordmark">
          <img src={`${process.env.PUBLIC_URL}/commonroom-logo.png`} alt="Common Room" />
        </div>
        <p className="fine" style={{ marginTop: 12 }}>
          Verified mentorship for competitive-activity families. Credentials checked against
          official competition records.
        </p>
        <NewsletterSignup
          variant="footer"
          source="footer"
          heading="One useful email a week — tips, answers, and webinar invites."
        />
      </div>
      <div className="cols">
        <div>
          <h4>Families</h4>
          <Link to="/mentors">Browse mentors</Link>
          <Link to="/family-signup">Create a family account</Link>
          <Link to="/data">The data</Link>
        </div>
        <div>
          <h4>Free resources</h4>
          <Link to="/resources/calendar">Deadline calendar</Link>
          <Link to="/resources/activity-map">Grade-by-grade map</Link>
          <Link to="/resources/webinars">Webinar library</Link>
          <Link to="/resources/qa">Q&amp;A digest</Link>
          <Link to="/resources/tips">Weekly tips</Link>
          <Link to="/resources/admit-profiles">College admit profiles</Link>
          <Link to="/amc/sample">Sample AMC contest</Link>
          <Link to="/data">The data</Link>
        </div>
        <div>
          <h4>For mentors</h4>
          <Link to="/become-a-mentor">Become a mentor</Link>
          <Link to="/mentor/dashboard">Mentor dashboard</Link>
        </div>
        <div>
          <h4>Trust</h4>
          <Link to="/data#method">How verification works</Link>
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
